import { DTOFileReference } from "../files";
import z from "zod";
export const DTOKnowledgeFileReferenceExtended = DTOFileReference.extend({
    /** File size in bytes */
    size: z.number().optional(),
});
export const DTOKnowledgeFile = z.object({
    id: z.string(),
    workspaceId: z.string(),
    createdByUserId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    contentUpdatedAt: z.string(),
    path: z.string(),
    description: z.string().max(1024),
    file: DTOKnowledgeFileReferenceExtended,
    isTextReadable: z.boolean(),
});
const DTOKnowledgeFileWritableFields = z.object({
    path: z.string(),
    description: z.string().max(1024),
    fileId: z.string(),
});
export const DTOKnowledgeFileCreatePayload = DTOKnowledgeFileWritableFields;
export const DTOKnowledgeFileUpdatePayload = DTOKnowledgeFileWritableFields.partial();
export const DTOKnowledgeFileDeletePayload = z.object({
    id: z.union([z.string(), z.array(z.string())]),
});
export const DTOKnowledgeFileListResponse = z.object({
    files: z.array(DTOKnowledgeFile),
});
export const DTOKnowledgeFileResponse = z.object({
    file: DTOKnowledgeFile,
});
export const DTOKnowledgeFileTextContent = z.object({
    content: z.string(),
    isTruncated: z.boolean(),
});
export const DTOKnowledgeFileDetail = DTOKnowledgeFile.extend({
    textContent: DTOKnowledgeFileTextContent.nullable(),
});
export const DTOKnowledgeFileDetailResponse = z.object({
    file: DTOKnowledgeFileDetail,
});
export const DTOKnowledgeFileDeleteResponse = z.object({
    deletedIds: z.array(z.string()),
});
